import BookInfo from './BookInfo'
import type { BookInfoProps } from './BookInfo.types'

export default BookInfo

export type { BookInfoProps }
